import { render, staticRenderFns } from "./bt.vue?vue&type=template&id=3bd9f964&scoped=true&"
import script from "./bt.vue?vue&type=script&lang=js&"
export * from "./bt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd9f964",
  null
  
)

export default component.exports